export default "__VITE_ASSET__CNMwuDmv__"